<template>
  <div class="container" :class="{'pad-btm': hasBuy}">
    <div class="page-card">
      <div class="card-title">
        <div class="title title1">天才都是训练的产物</div>
        <div class="title title2">我们更要提前练习</div>
      </div>
        <div class="header-title-common">
          <div class="title-wrap">
            <p>邀请大厂业务面试官</p>
            <p>100%还原BAT真实面试全流程</p>
          </div>
        </div>
        <div class="header-tip">
        </div>
    </div>
    <div class="page-card-1">
      <div class="header-title-common">
         <div class="title-wrap">
          <p>不同于市面上的HR模拟面试</p>
          <p>我们更有优势</p>
          </div>
      </div>
      <div class="card-poup">
        <div class="card-poup-item poup1">面试官均来自<br />一线大厂业务方</div>
        <div class="card-poup-item poup2">业务面试经验丰富<br />负责新人培养</div>
        <div class="card-poup-item poup3">更懂大厂用人要求<br />帮你衡量岗位差距</div>
        <div class="card-poup-item poup4">拉勾品牌担保<br />服务品质保证</div>
      </div>
      <div class="card-tip">
        模拟面试表现优秀者，有机会被面试官直接录取
      </div>
    </div>
    <div class="page-card-3">
      <div class="header-title-common">
         <div class="title-wrap">
          <p>根据个人需求，智能匹配面试官</p>
          <p class="sub-title">目前仅开放【前端、Java、大数据、测试】通道</p>
          </div>
      </div>
      <div class="indicate-wrap">
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_1.png" />
        <img
          class="indicate-img-line"
          src="../assets/img/h5/indicate_line_right.png"
        />
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_2.png" />
        <img
          class="indicate-img-line"
          src="../assets/img/h5/indicate_line_right.png"
        />
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_3.png" />
      </div>
      <div class="indicate-txt">
        <div class="indicate-txt-item">点击报名</div>
        <div class="indicate-txt-item">扫码添加工作人员</div>
        <div class="indicate-txt-item">匹配诊断官<br />预约诊断</div>
      </div>
      <div class="indicate-wrap indicate-wrap-other">
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_5.png" />
        <img
          class="indicate-img-line"
          src="../assets/img/h5/indicate_line_left.png"
        />
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_4.png" />
        <img
          class="indicate-img-pos"
          src="../assets/img/h5/indicate_line_down.png"
        />
      </div>
       <div class="card-tip">
        以下明星面试官均可预约
      </div>
       <div class="sw-box">
        <div class="swiper-container sw-container">
          <div class="swiper-wrapper current-wraps">
            <div class="swiper-slide sw-item"
                v-for="(tutor, index) in tutorList"
                :key="index"
            >
              <div class="sw-title">{{tutor.title}}</div>
              <div class="sw-item-header">
                <!-- <div class="sw-item-img">
                  <img class="sw-img" :src="tutor.img"/>
                </div> -->
                <div class="sw-info">
                  <div class="sw-name">{{ tutor.name }}</div>
                  <div class="sw-post">{{ tutor.post }}</div>
                  <div class="sw-labels">
                    <div class="label" v-for="(label, i) in tutor.labels" :key="i">{{ label }}</div>
                  </div>
                </div>
              </div>
              <div class="sw-bg">
                <img src="../assets/img/h5/sw-bottom.png" alt="">
              </div>
              <div class="sw-con">
                <div class="sw-con-txt"
                    :class="{
                        'sw-con-txt1': tutor.marks.length == 1
                    }"
                v-for="(mark, i) in tutor.marks" :key="i">{{ mark }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sw-tip">
        *更多方向及面试官信息可咨询工作人员
      </div>
    </div>
    <div class="page-card-4">
      <div class="header-title-common">
        <div class="title-wrap">
        <p>面试如此重要，一定要认真对待！</p>
        <p class="sub-title">不要面一次失败一次，让真正专业的人来帮助</p>
        </div>
      </div>
      <div class="learn-wrap">
        <div class="top flex">
          <div class="top-item flex item-wrap">
            <img src="../assets/img/h5/top-icon.png" alt="" class="item-icon item-icon1">
            <div class="tip-wrap">
              <p>刻意练习</p>
              <p>提升面试表达</p>
            </div>
          </div>
          <div class="top-item flex item-wrap">
            <img src="../assets/img/h5/top-icon1.png" alt="" class="item-icon item-icon2">
            <div class="tip-wrap">
              <p>以战养兵</p>
              <p>实战强化技巧</p>
            </div>
          </div>
          <div class="top-item flex item-wrap">
            <img src="../assets/img/h5/top-icon2.png" alt="" class="item-icon item-icon3">
            <div class="tip-wrap">
              <p>换位思考</p>
              <p>理解提问意图</p>
            </div>
          </div>
        </div>
        <div class="bottom flex">
          <div class="bottom-item flex item-wrap">
              <img src="../assets/img/h5/bottom-icon.png" alt="" class="item-icon item-icon4">
            <div class="tip-wrap">
              <p>化解套路</p>
              <p>增加面试信心</p>
            </div>
          </div>
          <div class="bottom-item flex item-wrap">
            <img src="../assets/img/h5/bottom-icon1.png" alt="" class="item-icon item-icon5">
            <div class="tip-wrap">
              <p>1V1交流</p>
              <p>亲密接触专家</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modal-container">
      <div class="modal">
        <div class="modal-close" @click="showModal = false"></div>
        <div class="modal-header">
          <img class="modal-header-img" src="../assets/img/h5/succeed_icon.png">
          <span class="modal-header-txt">报名成功</span>
        </div>
        <div class="modal-desc">添加小助手，预约专家服务</div>
        <img class="qrCode" :src="isApp ? qrCodeUrl : qrCodeUserUrl" />
        <div class="modal-btn" @click="openWeapp">{{ isApp ? '立即添加' : '长按图片识别' }}</div>
      </div>
    </div>
    <div class="footer-wrap">
      <div v-if="!hasBuy" class="footer">
        <div class="footer-left">
          <div class="price">
            <span class="symbol">￥</span>1<span class="cut">原价￥699</span>
          </div>
          <!-- <div class="price-tips">限量特惠</div> -->
        </div>
        <div class="footer-right"  @click="handleClick('支付按钮')">
          <span>立即预约BAT面试官</span>
          <img class="footer-img" src="../assets/img/h5/footer_icon.png" />
          <div class="right-tips">限时特惠</div>
          <img
            class="img-btns"
            src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
          />
        </div>
      </div>
      <div v-else class="footer-oth">
        <div class="footer-oth-left" @click="handleShowModal">获取专属能力诊断</div>
        <div class="footer-oth-right" @click="handleClick('¥699 购买')">¥699 购买</div>
      </div>
      <div class="footer-tips">
          付费即表示同意<span class="service" @click="toService">《拉勾增值服务协议》</span>
        </div>
    </div>
      <NewRetainModal
          :visible="retainModalVisible"
          title="真的要拒绝升职加薪的机会吗？"
          cancelBtnText="残忍拒绝"
          confirmBtnText="我再想想"
          :pageId="page_id"
          @onCancle="cancle"
          @onConfirm="removeHash"
        />
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import { purchasedCourse,postIsBuyCourse } from "../../../service/api";
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion';
import * as Cookies from 'js-cookie';
import LgPay from 'lg-pay';
import NewRetainModal from '../../../components/NewRetainModal/index.vue'
const lgPay = new LgPay();
export default {
  name: "InterviewCardH5",
  components: {
    NewRetainModal,
  },
  data() {
    return {
      tutorList: [
        {
          name: "猫猫",
          title:"Java",
          post: "腾讯架构师",
          labels: ["10年+大厂经验", "好评率100%"],
        },
        {
          name: "乌鱼",
          title:"前端",
          post: "阿里前端技术专家",
          labels: ["多家大厂经历", "金牌面试官"],
        },
        {
          title:"大数据",
          name: "小船",
          post: "美团技术专家",
          labels: ["负责新员工招聘", "深耕大数据领域"],
        },
         {
          title:"产品",
          name: "Noword",
          post: "字节跳动资深产品经理",
          labels: ["丰富一线项目经验", "深度理解人才模型"],
        },
         {
          title:"设计",
          name: "白求恩",
          post: "百度资深设计专家",
          labels: ["负责新人培养", "多年带团队经验"],
        },
      ],
      userList: [
        {
          name: "吴**",
          img: "https://s21.lgstatic.com/growth/activity/11-11/1604566029247.jpg",
          workYears: "工作5年",
          post: "Java高级开发工程师",
          mark: "不愧是大厂的技术大佬！真是一针见血，毫不留情地帮我找到了当前的问题，也让我清楚了自己努力的方向，告诉我接下来可以怎么做，我计划一年之内搞定大厂！",
        },
        {
          name: "花螺",
          img: "https://s21.lgstatic.com/growth/activity/11-11/1604566040664.jpg",
          workYears: "工作2年",
          post: "数据专员",
          mark: "诊断官的背景也太牛了哈哈，感觉他一眼就能看穿我。平时工作一直不知道自己优势在哪。这次有牛人给我建议，一下子让我有了信心和方向，太太太值得了！",
        },
        {
          name: "Zenn",
          img: "https://s21.lgstatic.com/growth/activity/11-11/1604566059669.jpg",
          workYears: "工作3年",
          post: "大数据开发工程师",
          mark: "特别感谢我的诊断老师，对我的岗位技能做了剖析，让我知道自己现在的水平对应名企的位置，给了我很大的信心，我终于鼓起勇气跟公司提了涨薪！",
        },
      ],
      showModal: false,
      hasBuy: true,
      isAndroid: navigator.userAgent.indexOf('Android') !== -1,
      qrCodeUserUrl: 'https://s20.lgstatic.com/growth/activity/20211215/1639548810152.png?x-oss-process=style/80',
      qrCodeUrl: 'https://s21.lgstatic.com/growth/activity/20211215/1639560244765.png?x-oss-process=style/80',
      retainModalVisible: false,
      page_id:'p1tg5'
    };
  },
  created() {
    // App支付成功显示弹窗
    window.lgBridge && window.lgBridge.response('nativePurchaseCallback', function (data, response, ext) {
      window.location.href = `${location.origin}${location.pathname}?hasBuy=1`
    });
    if (location.href.includes('hasBuy') && location.hash != '#refreshed') {
      location.hash = 'refreshed'
      this.showModal = true;
    }
  },
  mounted() {
    this.eduPlatTrack('WebView', {
        page_id: this.page_id
    });
    this.renderSwipers1();
    // if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token') || this.isApp) {
    //   this.purchasedCourse();
    // }
    // ios
    window.appBeforeGoBack = ()=> {
      this.watchHashChange();
      return 0
    }
    // android
    if (isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.4')) {
        window.appBeforeUnLoaded = ()=> {
           this.watchHashChange();
        }
    }
  },
  methods: {
    toService(){
      this.eduPlatTrack('WebButtonClick', {
            'page_id': this.page_id,
            'button_name': '增值服务协议按钮'
      });
      setTimeout(() => {
        this.goHref("https://activity.lagou.com/app/business/service-agreement.html")
      }, 200);
    },
    watchHashChange() {
        postIsBuyCourse().then(res => {
            if (res.state == 1) {
              let modalCount = localStorage.getItem('modalCount_'+this.page_id)
                if (res.content || (modalCount  && parseInt(modalCount) >= 3)) {
                   this.retainModalVisible = false
                    window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
                } else {
                    this.retainModalVisible = true;
                }
            }
        })
    },
    removeHash() {
        this.eduPlatTrack('WebButtonClick', {
            'page_id': this.page_id,
            'button_name': '模拟面试卡-我再想想'
        });
        this.retainModalVisible = false
    },
    purchasedCourse() {
      purchasedCourse().then(res => {
        if (res.state == 1) this.hasBuy = res.content || false;
      })
    },
    renderSwipers1() {
      let option = {
        effect: "coverflow",
        loop: true,
        speed: 1000,
        autoplay: 3000,
        slidesPerView: "auto",
        centeredSlides: true,
        coverflow: {
            rotate: 0,
            stretch: 106, // slide左右距离
            depth: 100, // slide前后距离
            modifier: 1, //
            slideShadows: true // 滑块遮罩层
        },
      };
      this.$nextTick(() => {
        const swiper = new Swiper(".sw-container", option);
      });
    },
    handleClick(buttonName) {
        if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
          return window.open('/frontLogin.do', '_self');
        }
        this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': buttonName
        });
        const expandInfo = `${location.origin}${location.pathname}?hasBuy=1`;
        const params = this.hasBuy ? {
          payLagouCoinNum: 699,
          sellGoodsPriceId: 104412,
          expandInfo
          } : {
            payLagouCoinNum: 1,
            sellGoodsPriceId: 104413,
            expandInfo
          }
        lgPay.submitV2(params, {
          payScenesKey: 'kai_wu',
          courseId: 1154
        }).then(() => {

        }).catch(() => {
        });
    },
    // 设置url
    setHashUrl(url = '') {
        let hashString = '';
        let finalString = url;
        if (url.indexOf('#') > -1) {
            const hashArr = url.split('#');
            hashString = `#${hashArr[1]}`;
            finalString = hashArr[0] || '';
        }
        return { finalString, hashString };
    },
    handleShowModal() {
      this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': "获取专属能力诊断"
        });
      if (this.isApp) {
        return this.openWeapp();
      }
      this.showModal = true;
    },
    openWeapp() {
      if (!this.isApp) {
        return;
      }
      this.showModal = false;
      window.lgBridge && window.lgBridge.request('check_install', {
        'data': {
            'app_names': ['wechat']
        }
      }, (res) => {
        if (res.data && res.data.data) {
          let { wechat } = res.data.data;
          if (wechat === 0) {
            /**
             * miniProgramType
             *    IOS: 1 小程序正式版  2 开发版  3 体验版
             *    安卓: 0 小程序正式版  1 开发版  2 体验版
             */
            const userName = 'gh_5bc6c955d1db';
            const path = `/pages/card/index.html`;
            const miniProgramType = this.isAndroid ? 0 : 1;
            const locationPath = encodeURIComponent(path);
            if (this.isEduApp) {
              const version = isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.2');
              const bridgeTitle = this.isAndroid ? version ? 'lgedu' : 'lgeduapp' : 'lgedu';
              const bridgeUrl = `${bridgeTitle}://lgedu.com/miniProgram?userName=${userName}&path=${locationPath}&miniProgramType=${miniProgramType}`;
              window.location = bridgeUrl;
            } else if (this.isLgApp) {
              const lgBridgeTitle = this.isAndroid ? 'lagouapp' : 'lagou';
              const lgPath = this.isAndroid ? path : locationPath;
              const lgBridgeUrl = `${lgBridgeTitle}://lagou.com/miniProgram?userName=${userName}&path=${lgPath}`;
              window.location = lgBridgeUrl;
            }
          } else {
            this.$message.warning('未安装微信');
          }
        }
      });
    },
    cancle(){
        this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': "模拟面试卡-残忍拒绝"
        });
       this.retainModalVisible = false;
       window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  min-height: 890px;
  background: url("../assets/img/h5/bg_header.png") no-repeat top #E9ECFF;
  background-size: 100% 890px;
  overflow-y: auto;
  padding-bottom: 259px;
  &.pad-btm {
    padding-bottom: 213px;
  }
  .header-title-common {
    width: 100%;
    padding: 60px 0 10px 0;
    // height: 68px;
    // line-height: 68px;
    text-align: center;
    color: #0C1784;
    font-size: 36px;
    font-weight: 600;
    background: url("../assets/img/h5/header_title_bg.png") no-repeat center;
    background-size: 100% 68px;
    .title-wrap{
      top: -28px;
      position: relative;
      .sub-title{
        font-size: 24px;
      }
    }
  }
    .header-tip{
      height: 275px;
      width: 100%;
      background: url("../assets/img/h5/header-tip.png") no-repeat center;
      background-size: 100% 100%;
    }
    .card-tip{
      color: #4650B0;
      font-weight: 500;
      font-size: 28px;
      text-align: center;
      margin-top: 33px;
    }
}
.bottom-btn {
  position: absolute;
  left: 50%;
  bottom: -47px;
  width: 368px;
  height: 94px;
  transform: translateX(-50%);
}
.page-card {
  position: relative;
  width: 722px;
  height: 628px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
  margin-top: 541px;
  padding: 17px 11px 0px 11px;
  box-sizing: border-box;
  .card-title {
    box-sizing: border-box;
    width: 100%;
    padding: 40px 0 35px 0;
    height:165px;
    font-size: 36px;
    color: #1423BD;
    background-color: rgba(232, 235, 255, .54);
    font-weight: 500;
    .title {
      position: relative;
      height: 44px;
      line-height: 44px;
      text-align: center;
      &.title1 {
        &::before {
          position: absolute;
          top: 0;
          left: 99px;
          content: "";
          display: inline-block;
          width: 28px;
          height: 25px;
          background: url("../assets/img/h5/quotes_left.png") no-repeat center;
          background-size: 28px 25px;
        }
      }
      &.title2 {
        text-indent: 12px;
        &::before {
          position: absolute;
          bottom: -12px;
          right: 99px;
          content: "";
          display: inline-block;
          width: 28px;
          height: 25px;
          background: url("../assets/img/h5/quotes_right.png") no-repeat center;
          background-size: 28px 25px;
        }
      }
    }
  }
}
.page-card-1 {
  position: relative;
  width: 722px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 7px;
  margin-top: 56px;
  padding: 4px 18px 49px 18px;
  box-sizing: border-box;
  .card-item {
    width: 100%;
    background-color: #f3f6ff;
    border-radius: 4px 18px 4px 4px;
    overflow: hidden;
    margin-bottom: 24px;
    .card-header {
      width: 100%;
      height: 51px;
      line-height: 51px;
      padding-left: 21px;
      box-sizing: border-box;
      font-size: 28px;
      font-weight: bold;
      color: #fff;
      &.bg-c-1 {
        background: linear-gradient(270deg, #0039da 0%, #0f1a92 100%);
      }
      &.bg-c-2 {
        background: linear-gradient(270deg, #6e91ff 0%, #0024f1 100%);
      }
      &.bg-c-3 {
        background: linear-gradient(270deg, #00d0ff 0%, #4070ff 100%);
      }
    }
    .card-content {
      padding: 23px 20px 13px 21px;
      box-sizing: border-box;
      font-size: 24px;
      line-height: 35px;
      color: #676767;
    }
  }
    .card-poup {
    display: flex;
    width: 100%;
    margin-top: 32px;
    flex-wrap: wrap;
    justify-content: space-between;
    .card-poup-item {
      flex-shrink: 0;
      width: 308px;
      height: 135px;
      margin-bottom: 13px;
      padding: 18px 0 0 13px;
      box-sizing: border-box;
      font-size: 28px;
      color: #333333;
      font-weight: 500;
      line-height: 42px;
      font-family: PingFangSC-Medium, PingFang SC;
      &.poup1 {
        background: url("../assets/img/h5/poup_bg_1.png") no-repeat center;
        background-size: 100% 100%;
      }
      &.poup2 {
        background: url("../assets/img/h5/poup_bg_2.png") no-repeat center;
        background-size: 100% 100%;
      }
      &.poup3 {
        background: url("../assets/img/h5/poup_bg_3.png") no-repeat center;
        background-size: 100% 100%;
      }
      &.poup4 {
        background: url("../assets/img/h5/poup_bg_4.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
}
.page-card-2 {
  width: 722px;
  height: 766px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
  margin-top: 56px;
  padding-top: 69px;
  box-sizing: border-box;
  .header-title-wrap {
    padding: 0 51px;
    box-sizing: border-box;
  }
  .header-title {
    position: relative;
    width: 100%;
    height: 68px;
    line-height: 68px;
    text-align: center;
    color: #0f286d;
    font-size: 36px;
    font-weight: bold;
    background: url("../assets/img/h5/header_title_bg.png") no-repeat center;
    background-size: 100% 68px;
    .title-1 {
      position: absolute;
      top: -24px;
      line-height: 41px;
      width: 100%;
      text-align: center;
    }
    .title-2 {
      position: absolute;
      bottom: -22px;
      width: 100%;
      line-height: 33px;
      font-size: 24px;
      font-weight: normal;
      color: #0f286d;
      text-align: center;
    }
  }
  .other-title {
    margin-top: 72px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    line-height: 33px;
    color: #0f286d;
  }
  .get-wrap {
    padding: 0 51px;
    margin-top: 29px;
    box-sizing: border-box;
    .get-wrap-inner {
      position: relative;
      width: 100%;
      height: 135px;
      border: 1px solid #000fff;
      border-radius: 4px;
      background-color: #f3f6ff;
      padding-top: 43px;
      box-sizing: border-box;
      .get-txt {
        font-size: 24px;
        text-align: center;
        color: #676767;
      }
      .get-title {
        position: absolute;
        top: -27px;
        left: 50%;
        width: 191px;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
        color: #fff;
        background: url("../assets/img/h5/header-txt-bg.png") no-repeat center;
        background-size: 191px 51px;
        transform: translateX(-50%);
      }
    }
  }
  .get-txt-img {
    display: block;
    width: 704px;
    height: 292px;
    margin: 39px auto 0;
  }
}
.box-title-wrap {
  padding: 0 65px;
  margin-top: 102px;
  box-sizing: border-box;
  .box-title {
    width: 100%;
    height: 68px;
    line-height: 68px;
    text-align: center;
    color: #0f286d;
    font-size: 36px;
    font-weight: bold;
    background: url("../assets/img/h5/header_title_bg.png") no-repeat center;
    background-size: 100% 68px;
  }
}
.sw {
  width: 100%;
  height: 336px;
  margin-top: 55px;
  /deep/ .current-container {
    width: 100%;
    height: 336px;
    .swiper-slide {
      width: 7.76rem;
      img {
        display: block;
        width: 7.76rem;
      }
    }
  }
  .sw-user-item {
    width: 625px;
    height: 336px;
    background-color: #fff;
    box-shadow: 0px 0px 15px 0px rgba(0, 94, 210, 0.24);
    border-radius: 6px;
    padding: 19px 10px 13px 12px;
    box-sizing: border-box;
    .user-wrap {
      display: flex;
      width: 100%;
      height: 66px;
      .user-img {
        width: 66px;
        height: 66px;
        margin-right: 18px;
        border-radius: 50%;
      }
      .user-info {
        flex: 1;
        .user-name {
          display: flex;
          align-items: center;
          height: 26px;
          font-size: 27px;
          font-weight: bold;
          color: #0f286d;
          .user-label {
            margin-left: 26px;
            padding: 0 11px;
            height: 26px;
            line-height: 26px;
            background-color: #5d89dd;
            font-size: 20px;
            color: #fff;
            text-align: center;
            font-weight: normal;
            border-radius: 13px;
          }
        }
        .user-desc {
          height: 24px;
          font-size: 24px;
          color: #6178cb;
          line-height: 36px;
          margin-top: 11px;
        }
      }
    }
    .user-txt {
      position: relative;
      width: 100%;
      padding: 10px 0 10px 19px;
      font-size: 28px;
      color: #49598b;
      line-height: 48px;
      box-sizing: border-box;
      margin-top: 24px;
      background-color: rgba(222, 234, 255, 0.4);
      border-radius: 4px;
      &::before {
        content: "";
        position: absolute;
        top: -30px;
        left: 16px;
        display: inline-block;
        border-bottom: 8px solid rgba(222, 234, 255, 0.4);
        border-top: 8px solid transparent;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
      }
    }
  }
//   .sw-user-item {
//     transform: scale(0.9);
//   }
//   .swiper-slide-active {
//     transform: scale(1);
//   }
}
.page-card-3 {
  width: 722px;
  margin: 0 auto;
  padding: 0  18px;
  background-color: #fff;
  border-radius: 7px;
  margin-top: 56px;
  box-sizing: border-box;
  .header-title-wrap {
    padding: 0 51px;
    box-sizing: border-box;
  }
  .sw-title{
    background: url("../assets/img/h5/sw-title-bg.png") no-repeat center;
    background-size: 100% 100%;
    color: #fff;
    font-size: 30px;
    transform: translate(-50%);
    left: 50%;
    top:0;
    position: absolute;
    width: 204px;
    height: 57px;
    text-align: center;
  }
  .sw-bg{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 129px;
    height: 117px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .header-title {
    position: relative;
    width: 100%;
    height: 68px;
    line-height: 68px;
    text-align: center;
    color: #0f286d;
    font-size: 36px;
    font-weight: bold;
    background: url("../assets/img/h5/header_title_bg.png") no-repeat center;
    background-size: 100% 68px;
    .title-3 {
      height: 41px;
      line-height: 41px;
      text-align: center;
    }
    .title-4 {
      font-size: 24px;
      font-weight: normal;
      line-height: 33px;
      text-align: center;
      margin-top: 4px;
    }
  }
  .indicate-wrap {
    display: flex;
    align-items: center;
    padding: 0 73px 0 78px;
    box-sizing: border-box;
    justify-content: space-between;
    &.indicate-wrap-other {
      position: relative;
      padding: 0 197px 0 190px;
      margin-top: 53px;
      .indicate-img-pos {
        position: absolute;
        top: -45px;
        right: 132px;
        width: 58px;
        height: 58px;
      }
    }
    .indicate-img {
      width: 104px;
      height: 104px;
    }
    .indicate-img-line {
      width: 78px;
      height: 24px;
    }
  }
  .indicate-txt {
    display: flex;
    margin-top: 5px;
    padding: 0 54px 0 74px;
    box-sizing: border-box;
    justify-content: space-between;
    font-size: 28px;
    line-height: 40px;
    font-weight: bold;
    color: #1f4ccb;
    &.indicate-txt-other {
      padding: 0 174px 0 157px;
    }
    .indicate-txt-item {
      text-align: center;
    }
  }
  .indicate-tips {
    font-size: 20px;
    line-height: 28px;
    color: rgba(102, 102, 102, 0.62);
    text-align: center;
    margin-top: 52px;
  }
}
.page-card-4 {
  width: 722px;
  margin: 0 auto;
  padding: 0  9px 30px 9px;
  margin-top: 56px;
  background-color: #fff;
  box-sizing: border-box;
  margin-bottom: 117px;
  border-radius: 7px;
  .top{
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }
  .item-icon{
    width: 53px;
    height: 55px;
    display: inline-block;
    margin-right: 9px;
  }
  .item-icon2{
    width: 43px;
    height: 57px;
  }
  .item-icon3{
    width: 43px;
    height: 57px;
  }
  .item-icon4{
    width: 47px;
    height: 43px;
  }
  .item-icon5{
    width: 44px;
    height: 53px;
  }
  .item-wrap{
    color: #1320A2;
    width: 226px;
    height: 114px;
    align-items: center;
    box-shadow: 0px 0px 8px 0px rgba(121, 126, 209, 0.43);
    border-radius: 14px;
    padding: 0 9px;
  }
  .bottom{
    justify-content: center;
    align-items: center;
    font-size: 24px;
    margin-top: 14px;
  }
  .item-wrap:not(:first-child){
    margin-left:12px;
  }
}
.modal-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  .modal {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    padding: 60px;
    box-sizing: border-box;
    .modal-header {
      display: flex;
      width: 180px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      justify-content: space-between;
      align-items: center;
      .modal-header-img {
        width: 40px;
        height: 40px;
      }
    }
    .modal-desc {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 40px;
      text-align: center;
      margin-top: 23px;
    }
    .qrCode {
      display: block;
      width: 350px;
      height: 350px;
      margin: 49px auto 0;
    }
    .modal-btn {
      height: 88px;
      line-height: 88px;
      background: #00B38A;
      border-radius: 4px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      margin-top: 42px;
    }
    .modal-close {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      bottom: -130px;
      border-radius: 50%;
      z-index: 10000;
      background: url("../assets/img/h5/icon_delect@2x.png") no-repeat center;
      background-size: 100%;
      transform: translateX(-50%);
    }
  }
}
.footer-wrap{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  height: 120px;
  padding-bottom: 83px;
  background-color: #fff;
  width: 100%;
  .footer-tips{
    width: 100%;
    font-size: 24px;
    text-align: center;
    color: #666666;
    margin-top: 16px;
  }
  .service{
    color: #0174DA;
  }
}
.footer {
  display: flex;
  flex: 1;
  width: 100%;
  padding: 0 52px;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  .footer-left {
    height: 156px;
    line-height: 156px;
    .price {
      margin-top: 4px;
      font-size: 68px;
      color: #ff5151;
      .symbol {
        font-size: 46px;
      }
      .cut {
        font-size: 30px;
        text-decoration: line-through;
      }
    }
    .price-tips {
      font-size: 41px;
      color: #666;
      line-height: 41px;
      text-indent: 8px;
      margin-top: -8px;
    }
  }
  .footer-right {
    position: relative;
    display: flex;
    width: 385px;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(180deg, #ffa351 0%, #ff4000 100%);
    border-radius: 6px;
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    align-items: center;
    text-align: center;
    padding-left: 51px;
    box-sizing: border-box;
    .footer-img {
      width: 12px;
      height: 30px;
      margin-left: 12px;
    }
    .right-tips {
      position: absolute;
      top: -64px;
      right: 54px;
      height: 42px;
      line-height: 42px;
      background-color: #ff5b5b;
      padding: 0 8px;
      border-radius: 4px;
      font-weight: normal;
      font-size: 22px;
      &::after {
        position: absolute;
        bottom: -12px;
        right: 10px;
        display: inline-block;
        content: "";
        border-top: 6px solid #ff5b5b;
        border-right: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #ff5b5b;
        z-index: -1;
      }
    }
    .img-btns {
      position: absolute;
      top: -10px;
      left: 0px;
      animation: left 1.5s infinite linear;
      width: 180px;
      height: 100px;
    }
    @keyframes left {
      0% {
        left: -10%;
      }
      50% {
        left: 100%;
      }
      100% {
        left: 200%;
      }
    }
  }
}
.swiper-content {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  padding: 50px 0;

  .show-swiper {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .swiper-slide {
      width: 500px;
      // 表示所有属性都有动作效果，过度时间为0.4s，以慢速开始和结束的过渡效果
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

      .swiper-item {
        width: 100%;
        height: 500px;
        background: rgb(140, 172, 134);
        border-radius: 6px;
        color: orangered;
        font-size: 24px;
        line-height: 1.5;
        border: 1px solid orangered;
      }
    }
  }
}
.footer-oth {
  display: flex;
  flex: 1;
  width: 100%;
  height: 110px;
  padding: 14px 40px;
  box-sizing: border-box;
  background-color: #fff;
  justify-content: space-between;
  .footer-oth-left {
    width: 420px;
    height: 82px;
    line-height: 82px;
    background: #F2FBF9;
    border-radius: 4px;
    border: 1px solid #00B38A;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #FF7536;
    text-align: center;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #FFA182;
  }
  .footer-oth-right {
    width: 230px;
    height: 87px;
    line-height: 82px;
    // background: #00B38A;
    background: linear-gradient(180deg, #FFA351 0%, #FF4000 100%);
    border-radius: 4px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }
}
@supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
  .footer-tips{
    padding-bottom:constant(safe-area-inset-bottom);
    padding-bottom:env(safe-area-inset-bottom);
  }
}
 .sw-box {
    width: 100%;
    height: 296px;
    margin: 44px 0 9px;
    /deep/ .sw-container {
      width: 100%;
      height: 296px;
    }
    /deep/ .swiper-slide-shadow-left, /deep/ .swiper-slide-shadow-right {
        background: rgba(198, 206, 238, 0.23);
    }
    .sw-item {
      width: 460px !important;
      height: 296px;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFF0E9 100%);
      box-shadow: 0px 0px 8px 0px rgba(149, 149, 149, 0.41);
      border-radius: 5px;
      // background: url("../assets/img/h5/sw-bottom.png") no-repeat;
      // border: 1px solid #FFFFFF;
      // overflow: hidden;
      .sw-item-header {
        display: flex;
        // width: 520px;
        height: 296px;
        // background-color: #e8f0ff;
        padding: 87px 0px 35px 0px;
        box-sizing: border-box;
        .sw-item-img {
          width: 114px;
          height: 114px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          .sw-img {
            width: 114px;
            height: 114px;
            border-radius: 50%;
          }
        }
        .sw-info {
          flex: 1;
          .sw-name {
            text-align: center;
            height: 45px;
            font-size: 34px;
            font-weight: bold;
            color: #333;
            line-height: 45px;
          }
          .sw-post {
            height: 40px;
            font-size: 29px;
            color: #fff;
            background: #FF9151;
            border-radius: 16px;
            margin: auto 44px;
            margin-top: 19px;
            text-align: center;
            line-height: 40px;
          }
          .sw-labels {
            width: 100%;
            height: 26px;
            margin-top: 18px;
            .label {
              flex-shrink: 0;
              height: 26px;
              line-height: 26px;
              margin-top:5px;
              padding: 0 10px;
              color: #666666;
              font-size: 26px;
              text-align: center;
              margin-right: 6px;
              border-radius: 13px;
            }
          }
        }
      }
      .sw-con {
        width: 100%;
        height: 97px;
        padding: 21px 0 18px;
        .sw-con-txt {
          font-size: 22px;
          color: #395dc0;
          line-height: 29px;
          text-align: center;
          &.sw-con-txt1 {
              margin: 16px;
          }
        }
      }
    }
    // .sw-item {
    //   transform: scale(0.9);
    // }
    // .swiper-slide-active {
    //   transform: scale(1);
    //   z-index: 9999 !important;
    // }
  }
  .sw-tip{
    color: #787878;
    font-size: 24px;
    text-align: right;
    padding-bottom: 28px;
  }
</style>
